import * as t from "io-ts";
import { unitT } from "./cargo-unit";
import nullable from "./nullable";
import { placeT } from "./place";
import { cargoTypeT } from "./types";
export const driverRouteVersionChangedT = t.strict({
    routeId: t.string,
    version: t.number,
});
export const createDriverRoutesTypes = ({ decimal, date, dateTime, }) => {
    const stopTypeT = t.union([t.literal("PICKUP"), t.literal("DROPOFF")]);
    const stopAttachmentT = t.strict({
        fileId: t.string,
        name: t.string,
        mimeType: t.string,
        url: t.string,
        documentType: t.union([t.literal("POD"), t.literal("IMAGE")]),
        previewId: nullable(t.string),
        driverId: t.string,
    });
    const stopT = t.strict({
        id: t.string,
        cargoId: t.string,
        type: stopTypeT,
        place: placeT,
        contact: nullable(t.string),
        phone: nullable(t.string),
        date: date,
        openingDate: nullable(date),
        openingTime: nullable(t.string),
        time: nullable(t.string),
        note: nullable(t.string),
        lm: decimal,
        units: t.array(t.strict({
            name: t.string,
            quantity: nullable(decimal),
            width: nullable(decimal),
            length: nullable(decimal),
            height: nullable(decimal),
            weight: nullable(decimal),
            volume: nullable(decimal),
        })),
        pieces: nullable(t.array(t.strict({ unit: unitT, quantity: t.number }))),
        height: nullable(decimal),
        length: nullable(decimal),
        width: nullable(decimal),
        weight: nullable(decimal),
        colli: nullable(decimal),
        cubicMeters: nullable(decimal),
        temperature: nullable(t.string),
        tag: nullable(t.string),
        fixTime: t.boolean,
        ref: nullable(t.string),
        coord: t.strict({
            lat: t.number,
            lon: t.number,
        }),
        measuredCubicMeters: nullable(decimal),
        measuredWeight: nullable(decimal),
        recordedRefs: t.array(t.strict({
            id: t.string,
            createdAt: dateTime,
            ref: t.string,
        })),
        completedAt: nullable(dateTime),
        arrivedAt: nullable(dateTime),
        departedAt: nullable(dateTime),
        attachments: t.array(stopAttachmentT),
        volumeAdded: t.boolean,
        weightAdded: t.boolean,
        comments: t.array(t.strict({
            id: t.string,
            createdAt: dateTime,
            comment: t.string,
        })),
        volumes: t.array(t.strict({
            id: t.string,
            createdAt: dateTime,
            cubicMeters: decimal,
        })),
        weights: t.array(t.strict({
            id: t.string,
            createdAt: dateTime,
            weight: decimal,
        })),
    });
    const clientT = t.strict({
        id: t.string,
        name: t.string,
        showArrivalDepartureToDriver: nullable(t.boolean),
        showAddCubicMetersToDriver: nullable(t.boolean),
    });
    const createdByT = t.union([t.literal("DISPATCHER"), t.literal("DRIVER")]);
    const driverRouteWaypointStopT = t.strict({
        type: t.literal("WAYPOINT"),
        waypoint: t.strict({
            waypointType: t.union([
                t.literal("AUTO_FIRST_STOP"),
                t.literal("MANUAL"),
                t.literal("FROM_START_ACTIVITY"),
                t.literal("FROM_END_ACTIVITY"),
            ]),
            note: nullable(t.string),
            place: placeT,
        }),
    });
    const driverRouteCargoStopT = t.strict({
        type: t.literal("CARGO_STOP"),
        stop: stopT,
    });
    const cargoTimeTrackingT = t.strict({
        started: nullable(dateTime),
        ended: nullable(dateTime),
        pauseResume: t.array(t.strict({
            type: t.union([t.literal("PAUSE"), t.literal("RESUME")]),
            time: dateTime,
        })),
    });
    const cargoT = t.strict({
        id: t.string,
        ref: t.string,
        deliveryId: t.string,
        revision: t.string,
        undeliveredLm: decimal,
        type: cargoTypeT,
        minTemperature: nullable(decimal),
        maxTemperature: nullable(decimal),
        invoiceRef: nullable(t.string),
        description: nullable(t.string),
        createdBy: createdByT,
        requestingDriverCanDeleteCargo: nullable(t.boolean),
        createdAt: dateTime,
        stops: t.array(t.string),
        clientId: nullable(t.string),
        driverCanAddDropoffs: t.boolean,
        driverCanMoveToUndispatched: t.boolean,
        timeTracking: nullable(cargoTimeTrackingT),
        equipment: t.array(t.strict({
            id: t.string,
            equipmentId: t.string,
            role: t.string,
            quantity: t.number,
            equipmentNumber: nullable(t.string),
            equipmentTypeName: nullable(t.string),
        })),
        siteJob: nullable(t.strict({
            groupId: t.string,
            kind: t.string,
            plannedQuantity: t.number,
            attachedCount: t.number,
        })),
    });
    const routeStartedEndedDataT = t.strict({
        dateTime: dateTime,
        odometer: nullable(decimal),
        note: nullable(t.string),
    });
    const driverRoutesResponseT = t.strict({
        routeId: t.string,
        ref: t.string,
        started: nullable(routeStartedEndedDataT),
        stopped: nullable(routeStartedEndedDataT),
        cargos: t.array(cargoT),
        clients: t.array(clientT),
        routeStops: t.array(t.union([driverRouteCargoStopT, driverRouteWaypointStopT])),
        createdBy: createdByT,
    });
    const driverRoutesResponseWithVersionT = t.strict({
        hasChanged: t.boolean,
        data: nullable(driverRoutesResponseT),
        version: t.number,
    });
    return {
        driverRoutesResponseT,
        driverRouteCargoStopT,
        driverRouteWaypointStopT,
        routeStartedEndedDataT,
        cargoT,
        stopT,
        stopAttachmentT,
        driverRoutesResponseWithVersionT,
        cargoTimeTrackingT,
    };
};
//# sourceMappingURL=driver-routes.js.map